module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_7042.bd7e6834.png";